import { types } from "mobx-state-tree";
import { IInboxEntry, InboxEntry } from "./InboxEntry";

export const InboxEntryReferenceType = types.reference(InboxEntry, {
  get(id: string, parent: any) {
    const entry = (parent as any).loadedEntries.find((e: IInboxEntry) => e.id === id);
    return (entry as IInboxEntry) || undefined;
  },
  set(value: IInboxEntry) {
    return (value && value.id) || "";
  }
});
